<template>
    <div class="page_container" v-loading="loading">
      <div class="add_btn_wrap">
        <el-button @click="handleClickDrafts" size="small" type="primary">
          草稿箱
        </el-button>
        <el-button @click="handleClickInviteLink" size="small" type="primary">
          邀请授权
        </el-button>
      </div>
        <el-table :data="tableData" border :height="tableHeight">
          <el-table-column label="编号" prop="id" align="center" width="80" show-overflow-tooltip></el-table-column>
          <el-table-column label="小程序名称" prop="wxapp_name" align="center" min-width="140" show-overflow-tooltip></el-table-column>
          <el-table-column label="小程序logo" prop="wxapp_logo" align="center" min-width="120" show-overflow-tooltip>
            <template slot-scope="{row}">
              <img v-if="row.wxapp_logo" :src="row.wxapp_logo" alt="" referrerpolicy="no-referrer" width="60px" height="60px">
            </template>
          </el-table-column>
          <el-table-column label="小程序二维码" prop="wxapp_qrcode" align="center" min-width="120" show-overflow-tooltip>
            <template slot-scope="{row}">
              <img v-if="row.wxapp_qrcode" :src="row.wxapp_qrcode" referrerpolicy="no-referrer" alt="" width="60px" height="60px">
            </template>
          </el-table-column>
          <el-table-column label="appid" prop="appid" align="center" min-width="180" show-overflow-tooltip> </el-table-column>
          <el-table-column label="管理员账号" prop="admins" align="center" width="160" show-overflow-tooltip>
            <template slot-scope="{row}">
              <span v-for="(item,key) in row.admins" :key="key">
                 {{item.phone}} <span v-if="row.admins.length -1 > key">,</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="授权时间" prop="created_at" align="center" min-width="120" show-overflow-tooltip> </el-table-column>
          <el-table-column label="操作" align="center" width="70"  fixed="right">
            <template slot-scope="{row}">
              <el-dropdown style="margin-left: 5px" placement="bottom" trigger="click">
                <el-button type="text" icon="el-icon-more"></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="handleClickBind(row)">绑定体验者</el-dropdown-item>
                  <el-dropdown-item @click.native="handleClickCommitTrial(row)">上传代码并生成体验版</el-dropdown-item>
                  <el-dropdown-item @click.native="handleClickTrialQRcode(row)">获取体验版二维码</el-dropdown-item>
                  <el-dropdown-item @click.native="handleClickSubmitAudit(row)">审核小程序</el-dropdown-item>
                  <el-dropdown-item v-if="row.auditid" @click.native="handleClickLookAudit(row)">查看审核状态</el-dropdown-item>
                  <el-dropdown-item v-if="row.auditid" @click.native="handleClickRelease(row)">发布小程序</el-dropdown-item>
                  <el-dropdown-item  @click.native="handleClickModifyServerDomain(row)">配置小程序服务器域名</el-dropdown-item>
                  <el-dropdown-item  @click.native="handleClickModifyJumpDomain(row)">配置小程序业务域名</el-dropdown-item>

                  <el-dropdown-item  @click.native="handleClickSetPrivacySetting(row)">设置小程序用户隐私</el-dropdown-item>
                  <el-dropdown-item  @click.native="handleClickGetPrivacySetting(row)">获取小程序用户隐私</el-dropdown-item>


                  <el-dropdown-item  @click.native="handleClickSpeedupCodeAudit(row)">加急代码审核</el-dropdown-item>
                  <el-dropdown-item  @click.native="handleClickGetVersionInfo(row)">查询小程序版本信息</el-dropdown-item>
                  <el-dropdown-item  @click.native="handleClickRevertCodeRelease(row)">小程序版本回退</el-dropdown-item>

                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pagination.pageNum"
                       :page-sizes="pagination.pageSizes"
                       :page-size="pagination.pageSize"
                       :layout="pagination.layout"
                       align="right"
                       :total="pagination.total">
        </el-pagination>

      <weChat_CommitTrial :weChatCommitTrialVisible.sync="weChatCommitTrialVisible" :weChatAppId="weChatAppId" @success="getTableData"  v-if="weChatCommitTrialVisible"/>
      <weChat_QRcode :weChatQRcodeVisible.sync="weChatQRcodeVisible" :weChatAppId="weChatAppId"  v-if="weChatQRcodeVisible"/>
      <weChat_Drafts :weChatDraftsVisible.sync="weChatDraftsVisible"    @success="getTableData"   v-if="weChatDraftsVisible"/>
      <modifyDomain :modifyDomainVisible.sync="modifyDomainVisible"  :modifyDomainType="modifyDomainType"  :weChatAppId="weChatAppId"   @success="getTableData"   v-if="modifyDomainVisible"/>

      <setPrivacySetting  :setPrivacySettingVisible.sync="setPrivacySettingVisible"   :weChatAppId="weChatAppId" v-if="setPrivacySettingVisible"/>
      <getPrivacySetting  :getPrivacySettingVisible.sync="getPrivacySettingVisible"   :weChatAppId="weChatAppId" v-if="getPrivacySettingVisible"/>

    </div>
</template>
<script>
    import {getTableStateHeight} from '@/utils'
    import {pagination} from '@/mixins'
    import {weChatCompanyList,getAuditStatus,submitAudit, wxRelease,bindTester,speedupCodeAudit,getVersionInfo,revertCodeRelease,} from '@/api'
    import weChat_CommitTrial from './wechat_commitTrial.vue'
    import weChat_QRcode from './wechat_qrcode.vue'
    import weChat_Drafts from './wechat_drafts'
    import modifyDomain from './modifyDomain'
    import setPrivacySetting from './set_privacySetting'
    import getPrivacySetting from './get_privacySetting'


    export default {
        name: 'company_management',
        mixins: [pagination],
        components: {
          weChat_CommitTrial,
          weChat_QRcode,
          weChat_Drafts,
          modifyDomain,
          setPrivacySetting,
          getPrivacySetting
        },
        data() {
            return {
                keyWord: '',
                tableData: [],
                tableHeight: undefined,//table高度
                loading: false,//加载动画
                resizeTimer: null, //节流定时器
                weChatCommitTrialVisible:false,
                weChatAppId:null,
                weChatQRcodeVisible:false,
                weChatDraftsVisible:false,

                modifyDomainType:'jump',
                modifyDomainVisible:false,

              setPrivacySettingVisible:false,
              getPrivacySettingVisible:false,
            }
        },
        mounted() {
            this.tableHeight = getTableStateHeight('page_container', 'el-form', 120)
            this.getTableData()
            window.onresize = () => {
                if (this.resizeTimer) {
                    clearTimeout(this.resizeTimer)
                }
                //开启定时器，节流函数
                this.resizeTimer = setTimeout(() => {
                    //将计算的table高度赋值给table
                    this.tableHeight = getTableStateHeight('page_container', 'el-form', 120)
                    //清除定时器
                    this.resizeTimer = null
                }, 100)
            }
        },
        methods: {
          // 草稿箱
          handleClickDrafts(){
            this.weChatDraftsVisible = true
          },
          handleClickInviteLink(){
            const origin = window.location.origin
            if (origin.indexOf('localhost') !== -1) {
              location.href = 'https://test.shenlan.enlightv.com/api/Wechat/createPreAuthorizationUrl'
            } else {
              if(origin.indexOf('test')>-1){
                location.href = 'https://test.shenlan.enlightv.com/api/Wechat/createPreAuthorizationUrl'
              }else{
                location.href = 'https://shenlan.enlightv.com/api/Wechat/createPreAuthorizationUrl'
              }
            }
          },

            getTableData() {
              this.loading = true
              weChatCompanyList({
                    page: this.pagination.pageNum,
                    pageSize: this.pagination.pageSize,
                }).then(res => {
                    if (res.code === 200) {
                        const {
                            data,
                            total
                        } = res.data
                        this.tableData = data
                        this.pagination.total = total
                    }
                    this.loading = false
                })
            },
            // 绑定体验者
            handleClickBind(row){
              this.$prompt('请输入微信号', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S/,
                closeOnClickModal:false,
                inputErrorMessage: '请输入微信号'
              }).then(({ value }) => {
                bindTester({wechatid:value},{
                  headers:{
                    appid: row.appid,
                  }
                }).then(res => {
                  if (res && res.code === 200) {
                    this.$message({
                      message: '绑定成功',
                      type: 'success',
                      duration: 2000,
                      onClose: () => { }
                    })
                    this.getTableData()
                  }
                  this.loading = false
                })

              }).catch(() => {


              });
            },

            handleClickCommitTrial(row){
              this.weChatAppId = row.appid
              this.weChatCommitTrialVisible = true
            },
            // 体验版二维码
            handleClickTrialQRcode(row){

              this.weChatAppId = row.appid
              this.weChatQRcodeVisible = true
            },
            // 查看审核状态
            handleClickLookAudit(row){
              getAuditStatus({auditid:row.auditid},{
                headers:{
                  appid: row.appid,
                }
              }).then(res => {
                if (res.code === 200) {
                  let {status,reason} = res.data

                  let message_text = status == 0 ? '审核成功' : status == 1 ? '审核被拒绝' : status == 2 ? '审核中' : status == 3 ? '审核已撤回' : '审核延后'
                  this.$alert(reason, message_text, {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    callback: action => {

                    }
                  });

                }
                this.loading = false
              })
            },
            // 审核小程序
            handleClickSubmitAudit(row){
              submitAudit({company_id:row.id},{
                headers:{
                  appid: row.appid,
                }
              }).then(res => {
                if (res && res.code === 200) {
                  this.$message({
                    message: res.message,
                    type: 'success',
                    duration: 2000,
                    onClose: () => { }
                  })
                  this.getTableData()
                }
                this.loading = false
              })
            },
            // 发布小程序
            handleClickRelease(row){
              if(!row.auditid){
                return false
              }
              getAuditStatus({auditid:row.auditid},{
                headers:{
                  appid: row.appid,
                }
              }).then(res => {
                if (res.code === 200) {
                  let {status} = res.data
                  if(status == 0){
                    wxRelease({auditid:row.auditid},{
                      headers:{
                        appid: row.appid,
                      }
                    }).then(res => {
                      if (res.code === 200) {
                        this.$message({
                            message: res.message,
                            type: 'success',
                            duration: 2000,
                            onClose: () => { }
                        })
                        this.getTableData()
                      }
                      this.loading = false
                    })

                  }else{
                    let message_text = status == 1 ? '审核被拒绝' : status == 2 ? '审核中' : status == 3 ? '审核已撤回' : '审核延后'
                    this.$message({
                      message: message_text,
                      type: 'error',
                      duration: 2000,
                      onClose: () => { }
                    })
                  }
                }
                this.loading = false
              })

            },

          handleClickModifyServerDomain(row){
            this.weChatAppId = row.appid
            this.modifyDomainType = 'server'
            this.modifyDomainVisible = true
          },
          handleClickModifyJumpDomain(row){
            this.weChatAppId = row.appid
            this.modifyDomainType = 'jump'
            this.modifyDomainVisible = true
          },
          // 设置小程序用户隐私
          handleClickSetPrivacySetting(row){
            this.weChatAppId = row.appid
            this.setPrivacySettingVisible  = true
          },
          // 获取小程序隐私设置
          handleClickGetPrivacySetting(row){
            this.weChatAppId = row.appid
            this.getPrivacySettingVisible  = true
          },
          // 加急代码审核
          handleClickSpeedupCodeAudit(row){
            this.$confirm('是否加急代码审核?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.loading = true

              speedupCodeAudit({auditid:row.auditid},{
                headers:{
                  appid: row.appid,
                }
              }).then(res => {
                if (res.errcode === 0) {
                  this.$message({
                    message: res.errmsg,
                    type: 'success',
                    duration: 2000,
                    onClose: () => { }
                  })
                }
                this.loading = false
              })

            }).catch(() => {

            });
          },
          // 查询小程序版本信息
          handleClickGetVersionInfo(row){
            this.loading = true
            getVersionInfo({},{
              headers:{
                appid: row.appid,
              }
            }).then(res => {
              if (res.errcode === 0) {

                let {exp_info,release_info} = res
                let str  = `体验版本：${exp_info.exp_version},<br/>版本描述：${exp_info.exp_desc},<br/>提交体验版时间：${this.formatTimestamp(exp_info.exp_time)}；<br/> <p style="height:'20px'"><br/></p>
                线上版本：${release_info.release_version},<br/>线上版本描述：${release_info.release_desc},<br/>提交线上版时间：${this.formatTimestamp(release_info.release_time)}。`

                this.$alert(str, '信息', {
                  dangerouslyUseHTMLString: true,
                  confirmButtonText: '确定',
                  callback: action => {

                  }
                });
              }
              this.loading = false
            })

          },
          // 小程序版本回退
          handleClickRevertCodeRelease(row){
            this.$confirm('是否小程序版本回退?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.loading = true
              revertCodeRelease({},{
                headers:{
                  appid: row.appid,
                }
              }).then(res => {
                if (res.errcode === 0) {
                  this.$message({
                    message: res.errmsg,
                    type: 'success',
                    duration: 2000,
                    onClose: () => { }
                  })
                }
                this.loading = false
              })

            }).catch(() => {

            });
          },
          formatTimestamp(timestamp) {
            const date = new Date(timestamp * 1000); // 转换为毫秒
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
          },

          handleSizeChange(val) {
                this.pagination.pageNum = 1
                this.pagination.pageSize = val
                this.getTableData()
            },

            handleCurrentChange(val) {
                this.pagination.pageNum = val
                this.getTableData()
            },

        },
    }
</script>
<style lang="scss">
  .alertCustomClass{
    max-height: 520px;
    width: 60% !important;
    .el-message-box__content{
      max-height: 420px;
      overflow: auto;
      word-break: break-all;
    }
  }
</style>
<style lang="scss" scoped>
.add_btn_wrap {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding: 0 0 12px 0;
  text-align: right;
}

</style>
